// extracted by mini-css-extract-plugin
export var copyableField = "_sc-4";
export var customerBadge = "_sc-0";
export var customerInfoTitle = "_sc-2";
export var details = "_sc-1";
export var dropdownContainer = "_sc-5";
export var dropdownImage = "_sc-6";
export var editAssigneeForm = "_sc-a";
export var editButton = "_sc-3";
export var email = "_sc-7";
export var hidden = "_sc-d";
export var input = "_sc-8";
export var saveButton = "_sc-b";
export var shopifyIcon = "_sc-c";
export var suggestionBadge = "_sc-e";
export var suggestionText = "_sc-f";
export var username = "_sc-9";